module.exports = __webpack_public_path__ + "static/media/icono (5).e2b5281d.svg";